import { UpDownChevronIcon, Z_INDEX } from '@vertex-protocol/web-ui';
import { TpSlPlaceOrderFormValues } from 'client/modules/trading/tpsl/hooks/useTpSlPlaceOrderForm/types';
import { TriggerCriteriaPriceType } from 'client/modules/trading/tpsl/tpslDialog/types';
import { useEffect, useRef, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';

interface Props {
  form: UseFormReturn<TpSlPlaceOrderFormValues>;
}

const OPTIONS = [
  {
    label: 'Last Price',
    value: 'last_price' as TriggerCriteriaPriceType,
  },
  {
    label: 'Oracle Price',
    value: 'oracle_price' as TriggerCriteriaPriceType,
  },
];

export function TpSlTriggerCriteriaPriceTypeSelect({ form }: Props) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const currentValue = form.watch('triggerCriteriaPriceType');
  const selectedLabel =
    OPTIONS.find((o) => o.value === currentValue)?.label ?? 'Oracle Price';

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div ref={containerRef} className="relative">
      <button
        type="button"
        className="bg-surface-1 text-text-secondary flex items-center gap-x-1 rounded-sm px-2 py-1 text-xs hover:brightness-125"
        onClick={() => setOpen((o) => !o)}
      >
        {selectedLabel}
        <UpDownChevronIcon open={open} />
      </button>
      {open && (
        <div className={`bg-surface-2 border-stroke shadow-elevation-strong absolute right-0 top-full mt-1 flex flex-col gap-y-0.5 rounded-sm border p-1 ${Z_INDEX.popover}`}>
          {OPTIONS.map(({ label, value }) => (
            <button
              key={value}
              type="button"
              className={`text-text-secondary hover:bg-overlay-hover whitespace-nowrap rounded-sm px-3 py-1.5 text-left text-xs ${
                value === currentValue ? 'text-text-primary' : ''
              }`}
              onClick={() => {
                form.setValue('triggerCriteriaPriceType', value);
                setOpen(false);
              }}
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
